export default "__VITE_ASSET__BkHToRKO__"